import { render } from "./AdminShipmentDashboard.vue?vue&type=template&id=63674138&scoped=true"
import script from "./AdminShipmentDashboard.vue?vue&type=script&lang=js"
export * from "./AdminShipmentDashboard.vue?vue&type=script&lang=js"

import "./AdminShipmentDashboard.vue?vue&type=style&index=0&id=63674138&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63674138"]])

export default __exports__